<template>
	<section>
		<div class="my-4">
			<h4>{{$t('lang.label.addcontacts')}}</h4>
		   <Form :schema="schema" :default="model"  @save="save($event)"></Form>
		</div>
	</section>
</template>

<script>
import { businessContactsService } from "@/_services";
import { mapActions } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Form from "@/components/Common/Form.vue";


export default {
	created(){
		this.model.enterprise = this.business.name
	},
	props: {
	    business: { type: Object },
	    client_id:  { type: Number },
	    link_id: {type:Number}
	},
	  components:{
	  	Form
	  },
	methods:{
		save(businessContact){
			businessContact.client_id = this.client_id
			businessContact.business_id = this.business.id
			businessContact.link_id = this.link_id
			businessContactsService.insert(businessContact).then(result => {
				if(result){
			      	this.$swal({
		              type: "success",
		              title: this.$t("lang.label.great"),
		              text: this.$t("lang.label.datasavedsuccessfully"),
		              showConfirmButton: false,
		              timer: 1500,
		            });
		    		this.$emit('refresh')
				}
		    });
		}
	},
	data() {
	    return {
	    	model: {},
	      	schema: {
		        fields: [
			          {
			            type: "input",
			            inputType: "text",
			            label: this.$t("lang.token.prospect_first_name"),
			            model: "first_name",
			            featured: true,
			            required: true,
			            styleClasses: "col-md-6",
			          },
			          {
			            type: "input",
			            inputType: "text",
			            label: this.$t("lang.token.prospect_last_name"),
			            model: "last_name",
			            featured: true,
			            required: true,
			            styleClasses: "col-md-6",
			          },
			          {
			            type: "input",
			            inputType: "text",
			            label: this.$t("lang.businessContactInfo.job"),
			            model: "job",
			            featured: true,
			            required: true,
			            styleClasses: "col-md-6",
			          },
			          {
			            type: "input",
			            inputType: "text",
			            label: this.$t("lang.businessContactInfo.company"),
			            model: "enterprise",
			            featured: true,
			            required: true,
			            disabled: true,
			            styleClasses: "col-md-6",
			          },
			          {
			            type: "input",
			            inputType: "text",
			            label: this.$t("lang.businessContactInfo.phone"),
			            model: "phone",
			            featured: true,
			            required: true,
			            styleClasses: "col-md-6",
			          },
			          {
			            type: "input",
            			inputType: "email",
			            label: this.$t("lang.label.email"),
			            model: "email",
			            featured: true,
			            required: true,
			            styleClasses: "col-md-6",
			          },
			          {
			            type: "input",
			            inputType: "text",
			            label: this.$t("lang.search.linkedin"),
			            model: "linkedinurl",
			            featured: true,
			            styleClasses: "col-md-6",
			          }
		        ]
	       } 
	    }
	},
}

</script>